import * as React from "react";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { FormHelperText } from "@mui/material";

export default function UiRadioInput(props) {
  const {
    label,
    value,
    name,
    defaultValue,
    onChange,
    error,
    groupLabel,
    children,
    className,
    formControlClass,
    ...rest
  } = props;

  const radioGroupClassName = `df-radio ${className ? className : "df-radio"}`;

  return (
    <FormControl className={formControlClass} error={!!error}>
      {groupLabel && (
        <FormLabel id="demo-radio-buttons-group-label">{groupLabel}</FormLabel>
      )}
      <RadioGroup
        aria-labelledby="df-radio-buttons-group-label"
        defaultValue={defaultValue}
        key={value}
        value={value}
        onChange={onChange}
        name={name}
        className={radioGroupClassName}
        {...rest}
      >
        {props?.children}
      </RadioGroup>

      {error && (
        <FormHelperText className="component-error-text">
          {error}
        </FormHelperText>
      )}
    </FormControl>
  );
}
